exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".admin-controller-type-column{display:inline-flex;min-width:max-content}.admin-controller-iosatellite-label{display:inline-flex;justify-content:center}.admin-controller-iosatellite-label>img{height:12px;padding-right:4px;margin-top:-3px}.admin-controller-relais{color:white}.admin-controller-relais-licenced{font-weight:bold}.admin-controller-slash{color:white;opacity:.8}.admin-controller-delete-column{color:white;width:100%;display:flex;justify-content:flex-end;align-items:center;padding-top:4px}.admin-controller-delete-column>i:hover{color:red}\n", ""]);

// exports
